import { render } from "./ReportSummaryTable.vue?vue&type=template&id=616abb65&scoped=true"
import script from "./ReportSummaryTable.vue?vue&type=script&lang=js"
export * from "./ReportSummaryTable.vue?vue&type=script&lang=js"

import "./ReportSummaryTable.vue?vue&type=style&index=0&id=616abb65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616abb65"]])

export default __exports__